import React from "react";
import { Link } from "react-router-dom";

import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

// import button from 'react-bootstrap/button';

import "./ShareClassButton.css";

function ShareClassButton(props) {
  let classDetails = props.classDetails;
  let teachers = props.teachers;
  let sharedWith = props.sharedWith;
  let name = props.name;
  let gradeLevel = props.gradeLevel;
  let rollNumber = props.rollNumber;
  let teacherEmail = props.teacherEmail;
  let schoolid = props.schoolid;

  return (
    <Link
      to={`/class/share`}
      state={{
        classDetails: { classDetails },
        teachers: { teachers },
        sharedWith: { sharedWith },
        name: { name },
        gradeLevel: { gradeLevel },
        rollNumber: { rollNumber },
        teacherEmail: { teacherEmail },
        schoolid: { schoolid },
      }}
    >
      <button className="light-blue-button share-class-button">
        Share Class <br></br> <img src="/assets/imgs/share.svg" />
      </button>
    </Link>
  );
}

export default ShareClassButton;
